/**
 * Branch Cart Event Tracking - Global
 * Tracks add to cart from ALL locations: PDP, PLP, Homepage, Quick View, etc.
 */

(function() {
  'use strict';

  /**
   * Track Branch Add to Cart Event
   * Listens to theme custom event (ajaxProduct:added)
   */
  document.addEventListener('ajaxProduct:added', function(e) {
    if (typeof branch === 'undefined' || !window.BranchEvents || typeof window.BranchEvents.trackAddToCart !== 'function') {
      return;
    }

    try {
      const productData = e.detail.product;
      if (!productData) return;

      // Prepare product data for Branch
      const branchProductData = {
        id: String(productData.product_id || productData.id),
        name: productData.product_title || productData.title,
        sku: productData.sku || '',
        price: parseFloat(productData.price ? productData.price / 100 : 0),
        quantity: parseInt(productData.quantity) || 1,
        variant: productData.variant_options ? productData.variant_options[0] : (productData.variant_title || ''),
        image_url: productData.image || productData.featured_image || '',
        currency: 'INR'
      };

      // Track the event
      window.BranchEvents.trackAddToCart(branchProductData);

    } catch (error) {
      // Silent fail - log only critical errors
      if (console && console.error) {
        console.error('Branch tracking error:', error);
      }
    }
  });

})();
